import { render, staticRenderFns } from "./AddPoints.vue?vue&type=template&id=42463602"
import script from "./AddPoints.vue?vue&type=script&lang=js"
export * from "./AddPoints.vue?vue&type=script&lang=js"
import style0 from "./AddPoints.vue?vue&type=style&index=0&id=42463602&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports